
const TableRow = ({first_time, first_lesson, first_lecturer, first_topic, first_detail, second_time, second_lesson, second_lecturer, second_topic, second_detail} ) => {
    return (
        <>
            <tr>
                <td rowSpan={4} className="long-column">
                    <span className="lecture-time">{first_time}</span>
                    <br />
                    <span className="lecture-hour-count">Ders Saati: 1</span>
                </td>
                <td className="lecture-name">Ders Adı: {first_lesson}</td>
                <td rowSpan={4} className="long-column">
                    <span className="lecture-time">{second_time}</span>
                    <br />
                    {
                        second_time && <span className="lecture-hour-count">Ders Saati: 1</span>
                    }
                </td>
                <td className="lecture-name">
                    {
                        second_time && <>Ders Adı: {second_lesson}</>
                    }
                </td>
            </tr>
            <tr>
                <td className = "td-start">
                    <p>
                        <strong>Ders Verecek Öğretim Üyesi:</strong> {first_lecturer}
                    </p>
                </td>
                <td className = "td-start">
                    <p>
                        {
                            second_time && <><strong>Ders Verecek Öğretim Üyesi:</strong> {second_lecturer}</>
                        }
                    </p>
                </td>
            </tr>
            <tr>
                <td className = "td-start">
                    <p>
                        <strong>Ders Konusu:</strong> {first_topic}
                    </p>
                </td>
                <td className = "td-start">
                    <p>
                        {
                            second_time && <><strong>Ders Konusu:</strong> {second_topic}</>
                        }
                    </p>
                </td>
            </tr>
            <tr>
                <td className = "td-start">
                    <p>
                        <strong>Detaylı Ders İçeriği:</strong>
                        {first_detail}
                    </p>
                </td>
                <td className = "td-start">
                    <p>
                        {
                            second_time && <><strong>Detaylı Ders İçeriği:</strong> {second_detail}</>
                        }
                    </p>
                </td>
            </tr>
        </>
    )
}

export default TableRow